import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import App from "./app/App";
import { LEVEL_4_ACR } from "./config";
import React from "react";
import { StorebrandKeycloak } from "@storebrand-digital/storebrand-auth";
import { initAxiosInterceptor } from "./utils/apiUtils";
import { initializeSentry } from "./utils/sentryUtils";
import { render } from "react-dom";
import assets from "./utils/assets";

async function confirmLevel4Auth() {
  if (StorebrandKeycloak.authenticated()) {
    const tokenParsed = await StorebrandKeycloak.getIdTokenParsed();
    return tokenParsed?.acr.includes(LEVEL_4_ACR) ?? false;
  } else {
    return false;
  }
}

StorebrandKeycloak.configure(
  {
    oidcProvider: window.env.KEYCLOAK_OIDC_PROVIDER,
    clientId: window.env.KEYCLOAK_CLIENT,
  },
  {},
  {
    scope: window.env.KEYCLOAK_SCOPES,
    allowedACR: ["https://id.storebrand.no/authn/al4"],
  },
);

StorebrandKeycloak.init().then(() => {
  window.micro.navbar.init("menu");
  window.micro.footer.init();

  initAxiosInterceptor();

  initializeSentry();

  confirmLevel4Auth().then((isLevel4Auth: boolean) => {
    if (!isLevel4Auth) {
      StorebrandKeycloak.login();
    }
  });

  assets.run();

  render(<App />, document.getElementById("root"));
});
